<template>
  <ion-page>
    <QuizHeader/>
    <ion-tabs>
      <!-- Chargement des sous-pages -->
      <ion-router-outlet></ion-router-outlet>
    </ion-tabs>
    <QuizNavigation/>
  </ion-page>
</template>

<script>

import {IonPage, IonRouterOutlet, IonTabs} from "@ionic/vue";
import QuizHeader from "@/components/QuizHeader.vue";
import QuizNavigation from "@/components/QuizNavigation.vue";

export default {
  name: 'QuizView',
  components: {
    QuizNavigation,
    IonPage,
    IonTabs,
    IonRouterOutlet,
    QuizHeader
  }
}
</script>

<style>

ion-card-title {
  font-size: 1.5rem;
}

ion-card-subtitle {
  font-size: 1.1rem;
}

</style>